import React from 'react'
import { Link } from 'react-router-dom';

export default function Navbar() {
    return (
        <>
            <header className="top-header">
                <nav className="navbar header-nav navbar-expand-lg">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="/"><img src="images/logo.png" alt="Logo-img" /></Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-wd" aria-controls="navbar-wd" aria-expanded="false" aria-label="Toggle navigation">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <div className="collapse navbar-collapse justify-content-end" id="navbar-wd">
                            <ul className="navbar-nav">
                                <li><Link className="nav-link active" to="/">Home</Link></li>
                                <li><Link className="nav-link active" to="/gallery">GALLERY</Link></li>
                                <li><Link className="nav-link" to="/about">About</Link></li>
                                <li><Link className="nav-link" to="/student">Verification</Link></li>
                                <li><Link className="nav-link" to="/get-franchise">FRANCHISE</Link></li>
                                <li><Link className="nav-link" to="/courses">Courses</Link></li>
                                <li><Link className="nav-link" to="/dashboard-student">DASHBOARD</Link></li>
                            </ul>
                        </div>

                    </div>
                </nav>
            </header>
        </>
    );
}